import { KeycloakService } from 'keycloak-angular';
// import { environment } from '../environments/environment';ss

export function initializer(keycloak: KeycloakService): () => Promise<any> {
  return async (): Promise<any> => {
    // console.log(window.location.href,"spp");
    const browserWindow: any = window;
    const browserWindowEnv = browserWindow['__env'] || {};
    const keycloakUrl = browserWindowEnv.keycloakUrl;
    const keycloakRealm = browserWindowEnv.keycloakRealm;
    const keycloakClientId = browserWindowEnv.keycloakClientId;

    if (!keycloakUrl || !keycloakRealm || !keycloakClientId) {
      console.warn('[auth-init] Missing Keycloak config in window.__env', {
        hostname: browserWindow?.location?.hostname,
        keycloakUrl,
        keycloakRealm,
        keycloakClientId,
      });
    }

    await keycloak.init({
      config: {
        url: keycloakUrl,
        realm: keycloakRealm,
        clientId: keycloakClientId,
        // credentials: {
        //   secret: 'secret_key'
        // }
      },
      loadUserProfileAtStartUp: false,
      initOptions: {
        onLoad: 'check-sso',
        checkLoginIframe: false,
      },
      bearerExcludedUrls: [],
    });
    return true;
  };
}
